import $ from 'jquery';

// TODO: Add short description
export default class TextSelection {
  constructor(textBlockSelector = '.js-text-selection') {
    this.$textBlock = $(textBlockSelector);

    this.init();
  }

  init() {
    this.isInitialized = true;

    if (!this.$textBlock.length) {
      this.isInitialized = false;

      return;
    }

    this.attachListeners();
  }

  // TODO: Rename to attachEventListeners
  attachListeners() {
    this.$textBlock.click((event) => {
      let range;
      let selection;

      if (window.getSelection && document.createRange) {
        range = document.createRange();
        range.selectNodeContents($(event.currentTarget)[0]);

        selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      } else if (document.selection && document.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText($(event.currentTarget)[0]);
        range.select();
      }
    });
  }
}
